<template>
	<div>
		<div class="home-page">
			<div class="bg"></div>
			<time-num></time-num>

			<div class="content">
				<div class="modelImg">
					<img :key="index" v-for="(item, index) in list" v-show="selectIndex === index * 5"
						:src="item.imgUrl" alt="" />
					<img class="imgAmplify" v-if="imgAmplify && type === 3" src="./../../assets/home/07.gif" alt="" />
					<img class="imgAmplify" v-if="imgAmplify && type === 4" src="./../../assets/home/09.gif" alt="" />
					<img class="imgAmplify" v-if="imgAmplify && type === 2" src="./../../assets/home/08.gif" alt="" />
				</div>

				<!-- <div v-if="type === 1">
          <div class="txt mt65">点击底部按钮即可旋转模型查看发光点</div>
        </div> -->
				<div v-if="type === 2">
					<img class="imgFix1" v-show="imgFlagList.imgFlag1 && !timer && !imgFlagList.imgFlag2"
						@click="handleShow" src="./../../assets/home/circle.png" alt="" srcset="" />
					<div class="txt mt65">点击底部按钮即可旋转模型查看发光点</div>
					<div class="txt" v-if="!imgFlagList.imgFlag2 && !timer && imgFlagList.imgFlag1">
						点击发光点下放载物台
					</div>
				</div>
				<div v-if="type === 3">
					<img class="imgFix2" v-show="imgFlagList.imgFlag2 && !timer" @click="handleShow"
						src="./../../assets/home/circle.png" alt="" srcset="" />
					<div class="txt mt65">点击底部按钮即可旋转模型查看发光点</div>
					<div class="txt" v-if="imgFlagList.imgFlag2 && !timer">
						点击发光点连接电源
					</div>
				</div>

				<div v-if="type === 4">
					<img class="imgFix3" v-show="imgFlagList.imgFlag3 && !timer && !imgFlagList.imgFlag1"
						@click="handleShow" src="./../../assets/home/circle.png" alt="" srcset="" />
					<div class="txt mt65">
						{{
              !isImgFlag
                ? "点击底部按钮即可旋转模型查看发光点"
                : "点击进入下一步"
            }}
					</div>
					<div class="txt" v-if="!imgFlagList.imgFlag1 && !timer && imgFlagList.imgFlag3">
						点击发光点复位至低倍镜
					</div>
				</div>
			</div>

			<!-- <div class="footer" v-if="!isImgFlag">
        <div @click="handlePrev" class="left">
          <img src="./../../assets/home/leftIcon.png" alt="" />
          左转
        </div>
        <div @click="handleNext" class="right">
          右转
          <img src="./../../assets/home/rightIcon.png" alt="" />
        </div>
      </div> -->
			<div class="footerBtn" v-if="isImgFlag">
				<div @click="handleGo" class="btn">开始考核</div>
			</div>
		</div>
		<img :key="index" style="display: none" v-for="(item, index) in list" :src="item.imgUrl" alt="" />
		<mi-xin></mi-xin>
	</div>
</template>

<script>
	import MiXin from "../mixins/index";
	import TimeNum from "../mixins/timeNum";
	import {
		mapMutations,
		mapState
	} from "vuex";
	import {
		getSlidePaper,
		submitExamCommitSingerAnswer,
	} from "@/api/system/exam";
	export default {
		name: "Home2026",
		components: {
			MiXin,
			TimeNum,
		},
		data() {
			return {
				type: 1,
				imgAmplify: false,
				imgStatus: false,
				count: "",
				timer: null,
				countdownTime: null,
				countdown: null,
				imgFlagList: {
					imgFlag1: true,
					imgFlag2: true,
					imgFlag3: true,
				},
				isShowTimeHeader: 1,
				list: [{
						imgUrl: require("./../../assets/home/xwj/0.png"),
					},
					{
						imgUrl: require("./../../assets/home/xwj/5.png"),
					},
					{
						imgUrl: require("./../../assets/home/xwj/10.png"),
					},
					{
						imgUrl: require("./../../assets/home/xwj/15.png"),
					},
					{
						imgUrl: require("./../../assets/home/xwj/20.png"),
					},
					{
						imgUrl: require("./../../assets/home/xwj/25.png"),
					},
					{
						imgUrl: require("./../../assets/home/xwj/30.png"),
					},
					{
						imgUrl: require("./../../assets/home/xwj/35.png"),
					},
					{
						imgUrl: require("./../../assets/home/xwj/40.png"),
					},
					{
						imgUrl: require("./../../assets/home/xwj/45.png"),
					},
					{
						imgUrl: require("./../../assets/home/xwj/50.png"),
					},
					{
						imgUrl: require("./../../assets/home/xwj/55.png"),
					},
					{
						imgUrl: require("./../../assets/home/xwj/60.png"),
					},
					{
						imgUrl: require("./../../assets/home/xwj/65.png"),
					},
					{
						imgUrl: require("./../../assets/home/xwj/70.png"),
					},
					{
						imgUrl: require("./../../assets/home/xwj/80.png"),
					},
					{
						imgUrl: require("./../../assets/home/xwj/85.png"),
					},
					{
						imgUrl: require("./../../assets/home/xwj/90.png"),
					},
					{
						imgUrl: require("./../../assets/home/xwj/95.png"),
					},
					{
						imgUrl: require("./../../assets/home/xwj/100.png"),
					},
					{
						imgUrl: require("./../../assets/home/xwj/105.png"),
					},
					{
						imgUrl: require("./../../assets/home/xwj/110.png"),
					},
					{
						imgUrl: require("./../../assets/home/xwj/115.png"),
					},
					{
						imgUrl: require("./../../assets/home/xwj/120.png"),
					},
					{
						imgUrl: require("./../../assets/home/xwj/125.png"),
					},
					{
						imgUrl: require("./../../assets/home/xwj/130.png"),
					},
					{
						imgUrl: require("./../../assets/home/xwj/135.png"),
					},
					{
						imgUrl: require("./../../assets/home/xwj/140.png"),
					},
					{
						imgUrl: require("./../../assets/home/xwj/145.png"),
					},
					{
						imgUrl: require("./../../assets/home/xwj/150.png"),
					},
					{
						imgUrl: require("./../../assets/home/xwj/155.png"),
					},
					{
						imgUrl: require("./../../assets/home/xwj/160.png"),
					},
					{
						imgUrl: require("./../../assets/home/xwj/165.png"),
					},
					{
						imgUrl: require("./../../assets/home/xwj/170.png"),
					},
					{
						imgUrl: require("./../../assets/home/xwj/175.png"),
					},
					{
						imgUrl: require("./../../assets/home/xwj/180.png"),
					},
					{
						imgUrl: require("./../../assets/home/xwj/185.png"),
					},
					{
						imgUrl: require("./../../assets/home/xwj/190.png"),
					},
					{
						imgUrl: require("./../../assets/home/xwj/195.png"),
					},
					{
						imgUrl: require("./../../assets/home/xwj/200.png"),
					},
					{
						imgUrl: require("./../../assets/home/xwj/205.png"),
					},
					{
						imgUrl: require("./../../assets/home/xwj/210.png"),
					},
					{
						imgUrl: require("./../../assets/home/xwj/215.png"),
					},
					{
						imgUrl: require("./../../assets/home/xwj/220.png"),
					},
					{
						imgUrl: require("./../../assets/home/xwj/225.png"),
					},
					{
						imgUrl: require("./../../assets/home/xwj/230.png"),
					},
					{
						imgUrl: require("./../../assets/home/xwj/235.png"),
					},
					{
						imgUrl: require("./../../assets/home/xwj/240.png"),
					},
					{
						imgUrl: require("./../../assets/home/xwj/245.png"),
					},
					{
						imgUrl: require("./../../assets/home/xwj/250.png"),
					},
					{
						imgUrl: require("./../../assets/home/xwj/255.png"),
					},
					{
						imgUrl: require("./../../assets/home/xwj/260.png"),
					},
					{
						imgUrl: require("./../../assets/home/xwj/265.png"),
					},
					{
						imgUrl: require("./../../assets/home/xwj/270.png"),
					},
					{
						imgUrl: require("./../../assets/home/xwj/275.png"),
					},
					{
						imgUrl: require("./../../assets/home/xwj/280.png"),
					},
					{
						imgUrl: require("./../../assets/home/xwj/285.png"),
					},
					{
						imgUrl: require("./../../assets/home/xwj/290.png"),
					},
					{
						imgUrl: require("./../../assets/home/xwj/295.png"),
					},
					{
						imgUrl: require("./../../assets/home/xwj/300.png"),
					},
					{
						imgUrl: require("./../../assets/home/xwj/305.png"),
					},
					{
						imgUrl: require("./../../assets/home/xwj/310.png"),
					},
					{
						imgUrl: require("./../../assets/home/xwj/315.png"),
					},
					{
						imgUrl: require("./../../assets/home/xwj/320.png"),
					},
					{
						imgUrl: require("./../../assets/home/xwj/325.png"),
					},
					{
						imgUrl: require("./../../assets/home/xwj/330.png"),
					},
					{
						imgUrl: require("./../../assets/home/xwj/335.png"),
					},
					{
						imgUrl: require("./../../assets/home/xwj/340.png"),
					},
					{
						imgUrl: require("./../../assets/home/xwj/345.png"),
					},
					{
						imgUrl: require("./../../assets/home/xwj/350.png"),
					},
					{
						imgUrl: require("./../../assets/home/xwj/355.png"),
					},
					{
						imgUrl: require("./../../assets/home/xwj/360.png"),
					},
				],
				selectIndex: 0,
				isImgFlag: false,
				selectImg: false,
				visibles: false,
				slideData: null,
				modelTimes: 10,
				isLoading: false,
				timeInfo: null,

			};
		},
		watch: {
			imgFlagList: {
				handler(val) {
					if (!val.imgFlag1 && !val.imgFlag2 && !val.imgFlag3) {
						this.isImgFlag = true;
					}
				},
				deep: true,
			},
		},
		created() {},
		mounted() {
			// this.handleGoMicroscopeStart();
			this.init();
		},
		computed: {
			...mapState("microscope", ["num", "slideType", "slidePaper", "examDetailId", "detail1", "detail2"]),
		},
		methods: {
			// vuex存放数据
			...mapMutations("microscope", ["handleMicroscope"]),
			...mapMutations("visualExamination", ["VISUAL_EXAMINATION"]),
			// 自动开始旋转
			init() {
				this.timer = setInterval(() => {
					if (this.selectIndex === 0) {
						this.selectIndex = 360;
					}
					if (this.selectIndex > 5) {
						this.selectIndex -= 5;
					} else {
						clearInterval(this.timer);
						this.timer = null;
						this.isImgFlag = true;
					}
				}, 50);
			},

			// 去开始
			handleGoMicroscopeStart() {
				getSlidePaper().then((response) => {
					this.handleMicroscope({
						key: "slidePaper",
						value: response.data.data.slidePaperModels,
					});
					this.handleMicroscope({
						key: "microscopeModleTime",
						value: true
					});

				});
			},

			// 下一步骤
			handleGo() {
				if (this.timer || this.imgAmplify) {
					return false;
				}
				let backendAnswers = {
					paper1Id: this.slidePaper[0].id,
					paper2Id: this.slidePaper[1].id,
					detail1: this.detail1,
					detail2: this.detail2,
				};
				submitExamCommitSingerAnswer({
					backendAnswers: JSON.stringify(backendAnswers),
					paperId: this.slideType,
					questionId: '-2',
					answers: JSON.stringify({
						detail1: this.detail1,
						detail2: this.detail2
					}),
					extractDetailId: this.examDetailId,
				}).then((response) => {
					this.$router.replace("/microscope/slide");
				});

			},
			// 上一步
			handlePrev() {
				if (this.timer || this.imgAmplify) {
					return false;
				}
				if (this.type < 4) {
					this.type++;
				} else {
					this.type = 1;
				}
				if (this.type === 1) {
					this.timer = setInterval(() => {
						if (this.selectIndex < 360) {
							this.selectIndex += 10;
						} else {
							if (this.selectIndex === 360) {
								this.selectIndex = 0;
							}
							clearInterval(this.timer);
							this.timer = null;
						}
					}, 50);
				} else if (this.type === 2) {
					this.timer = setInterval(() => {
						if (this.selectIndex < 90) {
							this.selectIndex += 10;
						} else {
							clearInterval(this.timer);
							this.timer = null;
						}
					}, 50);
				} else if (this.type === 3) {
					this.timer = setInterval(() => {
						if (this.selectIndex < 180) {
							this.selectIndex += 10;
						} else {
							clearInterval(this.timer);
							this.timer = null;
						}
					}, 50);
				} else if (this.type === 4) {
					this.timer = setInterval(() => {
						if (this.selectIndex < 270) {
							this.selectIndex += 10;
						} else {
							clearInterval(this.timer);
							this.timer = null;
						}
					}, 50);
				}
			},

			// 下一步
			handleNext() {
				if (this.timer || this.imgAmplify) {
					return false;
				}
				if (this.type > 1) {
					this.type--;
				} else {
					this.type = 4;
				}
				if (this.type === 4) {
					this.timer = setInterval(() => {
						if (this.selectIndex === 0) {
							this.selectIndex = 360;
						}
						if (this.selectIndex > 270) {
							this.selectIndex -= 5;
						} else {
							clearInterval(this.timer);
							this.timer = null;
						}
					}, 50);
				} else if (this.type === 3) {
					this.timer = setInterval(() => {
						if (this.selectIndex > 180) {
							this.selectIndex -= 5;
						} else {
							clearInterval(this.timer);
							this.timer = null;
						}
					}, 50);
				} else if (this.type === 2) {
					this.timer = setInterval(() => {
						if (this.selectIndex > 90) {
							this.selectIndex -= 5;
						} else {
							clearInterval(this.timer);
							this.timer = null;
						}
					}, 50);
				} else if (this.type === 1) {
					this.timer = setInterval(() => {
						if (this.selectIndex > 0) {
							this.selectIndex -= 5;
						} else {
							clearInterval(this.timer);
							this.timer = null;
						}
					}, 50);
				}
			},

			// 打开弹出gif图
			handleShow() {
				if (this.type === 2) {
					this.imgFlagList.imgFlag1 = false;
				} else if (this.type === 3) {
					this.imgFlagList.imgFlag2 = false;
				} else if (this.type === 4) {
					this.imgFlagList.imgFlag3 = false;
				}
				this.imgAmplify = true;
				this.countDown();
			},

			// 倒计时
			countDown() {
				let timeCount = 3;
				this.countdownTime = setInterval(() => {
					if (timeCount > 1) {
						timeCount--;
					} else {
						clearInterval(this.countdownTime);
						this.countdownTime = null;
						this.isShowTimeHeader = 0;
						this.imgAmplify = false;
					}
				}, 1000);
			},
		},
	};
</script>

<style lang="less" scoped>
	.home-page {
		width: 100%;
		min-height: 100vh;
		background-image: url("./../../assets/home/xwjBg.png");
		background-repeat: no-repeat;
		background-size: 100% 100%;

		// .bg {
		//   height: 90px;
		// }
		.modelImg {
			display: flex;
			align-items: center;
			width: 610px;
			height: 890px;
			margin: 0 auto;
			margin-top: 20px;
			border-radius: 60px;
			overflow: hidden;
			background: #ffffff;

			img {
				display: block;
				width: 85%;
				margin: 0 auto;
			}

			.imgAmplify {
				position: absolute;
				z-index: 1;
				display: block;
				width: 85%;
				margin: 0 auto;
			}
		}

		.content {
			width: 653px;
			min-height: calc(100vh - 90px);
			background: rgba(255, 255, 255, 0.3);
			box-shadow: 0px 30px 70px 0px rgba(13, 96, 103, 0.65);
			border-radius: 60px;
			margin: 0 auto;
			padding-top: 1px;
			position: relative;

			// overflow: hidden;
			.img {
				display: block;
				width: 610px;
				margin: 0 auto;
				margin-top: 20px;
				border-radius: 60px;
				overflow: hidden;
			}

			.imgFix1 {
				width: 120px;
				height: 120px;
				position: absolute;
				top: 605px;
				right: 100px;
			}

			.imgFix2 {
				width: 120px;
				height: 120px;
				position: absolute;
				top: 570px;
				right: 320px;
			}

			.imgFix3 {
				width: 120px;
				height: 120px;
				position: absolute;
				top: 400px;
				right: 300px;
			}

			.txt {
				line-height: 50px;
				font-size: 32px;
				font-family: HarmonyOS Sans SC;
				font-weight: 400;
				color: #ffffff;
				text-align: center;
			}

			.mt65 {
				margin-top: 65px;
			}
		}

		.footerSeize {
			height: 143px;
		}

		.footer {
			position: fixed;
			bottom: 0;
			width: 650px;
			height: 143px;
			background: linear-gradient(0deg, #ffffff, #e9f4f2);
			box-shadow: 0px -5px 50px 0px rgba(84, 84, 84, 0.07);
			border-radius: 60px 60px 0px 0px;
			padding: 40px 50px 0 50px;
			display: flex;

			.left {
				width: 310px;
				height: 88px;
				background: linear-gradient(132.74deg,
						rgba(0, 187, 177, 1) 0%,
						rgba(0, 86, 140, 1) 74.31%,
						rgba(171, 59, 127, 1) 100%),
					linear-gradient(135deg,
						rgba(0, 187, 177, 1) 0%,
						rgba(0, 83, 138, 1) 100%);
				border: 1px solid #ffffff;
				box-shadow: 0px 0px 10px 0px rgba(36, 36, 36, 0.29);
				line-height: 88px;
				border-radius: 44px;
				font-size: 35px;
				font-family: HarmonyOS Sans SC;
				font-weight: 500;
				color: #ffffff;

				img {
					width: 40px;
					margin-left: 48px;
					margin-right: 64px;
					vertical-align: middle;
				}
			}

			.right {
				width: 310px;
				height: 88px;
				background: linear-gradient(132.74deg,
						rgba(0, 187, 177, 1) 0%,
						rgba(0, 86, 140, 1) 74.31%,
						rgba(171, 59, 127, 1) 100%),
					linear-gradient(135deg,
						rgba(0, 187, 177, 1) 0%,
						rgba(0, 83, 138, 1) 100%);
				border: 1px solid #ffffff;
				box-shadow: 0px 0px 10px 0px rgba(36, 36, 36, 0.29);
				line-height: 88px;
				border-radius: 44px;
				margin-left: 30px;
				font-size: 35px;
				font-family: HarmonyOS Sans SC;
				font-weight: 500;
				color: #ffffff;
				text-align: center;
				text-indent: 64px;

				img {
					width: 40px;
					margin-left: 64px;
					margin-right: 48px;
					vertical-align: middle;
				}
			}
		}

		.footerBtn {
			position: fixed;
			bottom: 0;
			width: 650px;
			height: 143px;
			background: linear-gradient(0deg, #ffffff, #e9f4f2);
			box-shadow: 0px -5px 50px 0px rgba(84, 84, 84, 0.07);
			border-radius: 60px 60px 0px 0px;
			padding: 40px 50px 0 50px;

			.btn {
				width: 310px;
				margin: 0 auto;
				height: 88px;
				background: linear-gradient(132.74deg,
						rgba(0, 187, 177, 1) 0%,
						rgba(0, 86, 140, 1) 74.31%,
						rgba(171, 59, 127, 1) 100%),
					linear-gradient(135deg,
						rgba(0, 187, 177, 1) 0%,
						rgba(0, 83, 138, 1) 100%);
				border: 1px solid #ffffff;
				box-shadow: 0px 0px 10px 0px rgba(36, 36, 36, 0.29);
				line-height: 88px;
				border-radius: 44px;
				font-size: 35px;
				font-family: HarmonyOS Sans SC;
				font-weight: 500;
				color: #ffffff;
				text-align: center;
			}
		}
	}

	::v-deep .van-dialog {
		border-radius: 0;
		width: 98%;
		background: none;

		.van-dialog__content {
			width: 100%;
		}

		.imgAmplify {
			width: 80%;
			margin: 0 auto;

			img {
				width: 100%;
			}
		}
	}
</style>